import React from 'react';
import { Box, Typography } from '@mui/material';
import { CONTENT_MAX_WIDTH, TEXT_MAX_WIDTH, accentRuleSx } from '../styles/tokens';
import { BORDER, SHADOW_CARD, SURFACE } from '../pages/Practice/map/mapTokens';
import { bandSx } from './home/homeUi';

const AboutUs = ({ tone }) => {
  return (
    <Box
      component="section"
      sx={{
        ...bandSx(tone),
        '& strong': {
          color: 'primary.main',
          fontWeight: 700,
        },
      }}
    >
      {/* Two columns: the story on the left, the mark on the right. The section
          previously left the whole right-hand half empty, and the logo sat beside
          the heading where it competed with it for the same line. */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr auto' },
          alignItems: 'center',
          gap: { xs: 4, md: 6 },
          maxWidth: CONTENT_MAX_WIDTH,
          mx: 'auto',
        }}
      >
        <Box>
          <Typography variant="h3" component="h2" fontWeight={900} color="primary.main" sx={{ mb: 1.5 }}>
            Who are we?
          </Typography>
          <Box aria-hidden sx={{ ...accentRuleSx, mb: 3 }} />
          <Box
            sx={{
              maxWidth: TEXT_MAX_WIDTH,
              lineHeight: 1.8,
              color: 'text.primary',
              fontSize: { xs: '1rem', sm: '1.1rem' },
              '& p': {
                marginBottom: 3,
              },
            }}
          >
            {/* Left-aligned, not centred. Four centred paragraphs give the eye a
              new starting point on every line, which is measurably slower to
              read at this length. */}
            <Typography variant="body1" component="p" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
              We built the site we wish we had when we were in your shoes.
            </Typography>
            <Typography variant="body1" component="p" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
              As full-time tech workers in Switzerland, language learning didn't come naturally to us. Between
              traditional schools, tutors, and late-night study sessions, passing the <strong>fide test</strong> for our
              C permits was a real journey. Frustrated by the lack of focused tools, we teamed up to build the digital
              platform we desperately needed.
            </Typography>
            <Typography variant="body1" component="p" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
              Today, we help expats conquer the <strong>fide test</strong> efficiently. Every exercise is designed from
              a real learner's perspective and verified by experts.
            </Typography>
            <Typography variant="body1" component="p" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
              If we could balance full-time jobs and pass, you can too. <strong>Let's get you ready!</strong>
            </Typography>
          </Box>
        </Box>

        {/* The mark sits in a soft disc rather than floating loose. On bare white
            it read as a stray graphic; contained, it becomes a deliberate
            element — and it is the same soft-blue-on-a-tile idiom the icons use
            everywhere else, just larger and round. */}
        <Box
          sx={{
            width: { xs: 150, md: 220 },
            height: { xs: 150, md: 220 },
            borderRadius: '50%',
            bgcolor: SURFACE,
            border: `1px solid ${BORDER}`,
            boxShadow: SHADOW_CARD,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            justifySelf: { xs: 'center', md: 'end' },
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt=""
            aria-hidden
            width="120"
            height="120"
            loading="lazy"
            sx={{ width: { xs: 88, md: 132 }, height: 'auto', display: 'block' }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUs;
